import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const MeetKGOB = () => {
  return (
    <section
      className="bg-white py-16 lg:py-20"
      data-testid="meet-kgob-section"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-semibold text-[#0B2240] mb-6">
            Meet KGOB — The CPA Firm Behind Let's Talk Taxes
          </h2>
          
          <p className="text-lg text-[#4C5A70] leading-relaxed mb-8">
            We're a local, relationship-driven CPA firm helping families and business owners with tax, accounting, and growth planning. Let's Talk Taxes is our CPA-led product line—backed by real people and real support.
          </p>

          <div className="flex flex-wrap justify-center gap-4 text-sm mb-8">
            <a data-testid="meet-k-g-o-b-a-3"
              href="/#difference"
              className="text-[#D4AF37] hover:text-[#B99610] font-medium underline underline-offset-4 transition-colors"
            >
              About KGOB
            </a>
            <span className="text-[#4C5A70]">•</span>
            <a data-testid="meet-k-g-o-b-a-2"
              href="/#services"
              className="text-[#D4AF37] hover:text-[#B99610] font-medium underline underline-offset-4 transition-colors"
            >
              Our Services
            </a>
            <span className="text-[#4C5A70]">•</span>
            <a data-testid="meet-k-g-o-b-a-1"
              href="/community"
              className="text-[#D4AF37] hover:text-[#B99610] font-medium underline underline-offset-4 transition-colors"
            >
              Events
            </a>
          </div>
          
          {/* New: Link to Meet KGOB landing page */}
          <a
            href="/our-story"
            className="inline-flex items-center gap-2 text-[#0B2240] hover:text-[#D4AF37] font-medium transition-colors group"
            data-testid="meet-kgob-ltt-link"
          >
            Meet the Team Behind KGOB
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
